import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  stepEnum,
  getGeneralData,
  resetState,
  closeModal,
  setIsPrivate,
  validateAccountToIMEIService,
  setNumberCallCenter,
  setCurrentStep, popUpEnum,
  setSelectedPhoneNumber,
  getSubscriberList,
  setIsInitialized
} from './IMEIDeviceRepairSlice';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import ValidateComponent from './Steps/ValidateComponent';
import IMEISelection from './Steps/IMEISelection';
import SubscriberSelection from './Steps/SubscriberSelection'
import CauseSelection from './Steps/CauseSelection';
import ErrorComponent from './Steps/ErrorComponent';
import UpdateDeliveries from './Steps/UpdateDeliveries';
import PickUpAddressSelection from './Steps/PickUpAddressSelection';
import DeliveryAddressSelection from './Steps/DeliveryAddressSelection';
import CompletedComponent from './Steps/CompletedComponent';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import PopUp from '../../Shared/Popup/PopUp';
import CurrentOrgIdToSelectedAccount from './Popups/CurrentOrgIdToSelectedAccount';
import FindMyIphone from './Popups/AlertPopUp';
import DeliveriesFound from './Popups/DeliveriesFound';
import Config from "../../../Config";
import ImeiHelp from 'app/Components/Block/IMEIDeviceRepairBlock/Popups/ImeiHelp';
import AlertPopUp from './Popups/AlertPopUp';
import OtpStep from 'app/Components/Block/IMEIDeviceRepairBlock/Steps/OtpStep';

const IMEIDeviceRepairMain = (props) => {
  const {setIsPrivate, deviceRepairData, loginData, setCurrentStep, resetState, isInitialized, setIsInitialized} = props;
  const {isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated} = loginData;

  useEffect(() => {
        if (props.contentData?.isPrivate?.value) {
            props.setNumberCallCenter(Config.idfCellcomCenter);
        } else {
            props.setNumberCallCenter(Config.businessCallNumber);
        }
    }, [props.orgId]);


  useEffect(() => {

    setIsPrivate(props.contentData?.isPrivate?.value || false);

    if (!isFullAuthenticated && !isOtpAuthenticated && !isOtpExtendedAuthenticated && props.contentData.isFromPrivateSelfcare.value) {
      setCurrentStep(stepEnum.OTP);
      return;
    }

    if (!isInitialized) {
      init();
    }

    return () => {
      resetState();
    };
  }, []);

  useClearStateResetFlag();

  async function init() {
    if (props.contentData.isFromPrivateSelfcare.value && !isInitialized) {
      props.setSelectedPhoneNumber(props.loginData.userDetails.contactNumber);
       await props.getSubscriberList().then(async (res) => {
          if (res.payload?.data?.length > 1) {
              setCurrentStep(stepEnum.SELECT_SUBSCRIBER)
          } else {
              let validationParams = {
                  startPoint: props.deviceRepairData.startPoint,
                  selectedNumber: props.loginData.userDetails.contactNumber,
                  selectedIMEI: props.deviceRepairData.form.imei,
                  isPrivate: props.deviceRepairData?.isPrivate,
                  isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value === true
              };

              const result = await props.validateAccountToIMEIService(validationParams);

              if (!result.payload.error && !result.payload.serverError) {
                  setCurrentStep(stepEnum.SELECT_IMEI);
              }
          }
      })
    } else {
      setCurrentStep(stepEnum.VALIDATION);
    }

    setIsInitialized(true);
  }

  const currentStep = () => {
        switch (props.deviceRepairData.currentStep) {
          case stepEnum.OTP:
            return <OtpStep contentData={props.contentData}/>;
          case stepEnum.VALIDATION:
            return <ValidateComponent context={props.context} contentData={props.contentData} />;
            case stepEnum.SELECT_IMEI:
                return <IMEISelection context={props.context} contentData={props.contentData}/>;
            case stepEnum.SELECT_SUBSCRIBER:
                return <SubscriberSelection context={props.context} contentData={props.contentData}/>;
            case stepEnum.CAUSE_SELECTION:
                return <CauseSelection contentData={props.contentData}/>;
            case stepEnum.UPDATE_DELIVERIES:
                return <UpdateDeliveries props={props.context} contentData={props.contentData}/>;
            case stepEnum.PICK_UP_ADDRESS:
                return <PickUpAddressSelection contentData={props.contentData}/>;
            case stepEnum.DELIVERY_ADDRESS:
                return <DeliveryAddressSelection contentData={props.contentData}/>;
            case stepEnum.COMPLETED:
                return <CompletedComponent context={props.context} contentData={props.contentData}/>;
            case stepEnum.ERROR:
            case stepEnum.IS_LOCKED_FAILED:
                return <ErrorComponent context={props.context} contentData={props.contentData}/>;
        }
    };

  const getCurrentPopup = () => {
      switch (props.deviceRepairData.popUp) {
        case popUpEnum.MEMBER_OF_DIFFERENT_ORG:
                return <CurrentOrgIdToSelectedAccount closeModal={closeModal}
                                                      selectedAccountOrgId={props.deviceRepairData.selectedAccountOrgId}/>;
        case popUpEnum.IS_LOCKED:
                return <FindMyIphone/>;
        case popUpEnum.DELIVERIES_FOUND:
                return <DeliveriesFound/>;
        case popUpEnum.IMEI_HELP:
          return <ImeiHelp />;
        case popUpEnum.WARR_ISSUR_IND:
          return <AlertPopUp />;
        case popUpEnum.GENERAL_ERRROR:
          return <AlertPopUp />;
        }
    };

    return (
      <div className={`imei-device-repair-main-container`}>
            {currentStep()}
          <PopUp className={'imei-device-repair-popup'}
                 showPopUp={props.deviceRepairData.popUp !== null && props.deviceRepairData.popUp !== undefined}
                 onClose={() => props.closeModal()}>
                {getCurrentPopup()}
            </PopUp>
      </div>
    );
};

const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    orgId: state.welcomeBlock.orgId,
    loginData: state.authentication.loginData
  };
};

const mapDispatchToProps = {
    getGeneralData,
    resetState,
    showAppLoader,
    hideAppLoader,
    closeModal,
    setIsPrivate,
    validateAccountToIMEIService,
    setNumberCallCenter,
    setCurrentStep,
    setSelectedPhoneNumber,
    getSubscriberList,
    setIsInitialized
};

export default connect(mapStateToProps, mapDispatchToProps)(IMEIDeviceRepairMain);
